export default __webpack_public_path__ + "464e7fd0f582dee89cdb2333cad22b0d.woff";